import React from 'react';

export default function StatusIconInit({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Source-Slideout-Panel-View"
          transform="translate(-1214.000000, -163.000000)"
          fill={color}
        >
          <path
            d="M1227.70495,171.247374 L1223.00212,171.247374 C1222.58787,171.247374 1222.25079,170.910293 1222.25079,170.496048 L1222.25079,163.750474 C1222.25079,163.019463 1221.31671,162.722991 1220.89028,163.315934 L1214.14055,174.187742 C1213.78723,174.683206 1214.14055,175.373608 1214.74973,175.373608 L1219.4405,175.373608 C1219.85475,175.373608 1220.19183,175.710689 1220.19183,176.124935 L1220.19183,182.874666 C1220.19183,183.605677 1221.12591,183.902149 1221.55234,183.309206 L1228.31829,172.43324 C1228.66756,171.937776 1228.31423,171.247374 1227.70505,171.247374 L1227.70495,171.247374 Z"
            id="Change-Status-Icon"
          ></path>
        </g>
      </g>
    </svg>
  );
}

StatusIconInit.defaultProps = {
  width: '15px',
  height: '20px',
  color: '#6D7E8F',
};
